import { defineMessages } from 'react-intl';

export default defineMessages({
    loadingNextPageMessage: {
        id: 'rewrite.eu.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    policyType: {
        id: 'rewrite.eu.Underlying Policy.Policy Type',
        defaultMessage: 'Policy Type'
    },
    carrierName: {
        id: 'rewrite.eu.Underlying Policy.Insurer',
        defaultMessage: 'Insurer'
    },
    ULPolicyDetails: {
        id: 'rewrite.eu.Underlying Policy.UL Policy Details',
        defaultMessage: 'UL Policy Details'
    },
    policyNumber: {
        id: 'rewrite.eu.Underlying Policy.Policy Number',
        defaultMessage: 'Policy Number'
    },
    delete: {
        id: 'rewrite.eu.Underlying Policy.Delete',
        defaultMessage: 'Delete'
    },
    removeUnderlyingPolicy: {
        id: 'rewrite.eu.Underlying Policy.Remove?',
        defaultMessage: 'Remove Underlying Policy?'
    },
    removeEAVehicleExposure: {
        id: 'rewrite.eu.Underlying Policy.Remove EA Vehicle Exposure?',
        defaultMessage: 'Remove Vehicle Exposure?'
    },
    removeAdditionalPremise: {
        id: 'rewrite.eu.Underlying Policy.Remove Additional Premise',
        defaultMessage: 'Remove Additional Premise?'
    },
    removeAddress: {
        id: 'rewrite.eu.Underlying Policy.Remove Address',
        defaultMessage: 'Remove Address?'
    },
    confirmDelete: {
        id: 'rewrite.eu.Underlying Policy.Confirm Delete',
        defaultMessage: 'Please Confirm Delete.'
    },
    cancel: {
        id: 'rewrite.eu.Underlying Policy.Cancel',
        defaultMessage: 'Cancel'
    },
    allUnderlyingPolicisAdded: {
        id: 'rewrite.eu.Underlying Policy.All Underlying Policies Added',
        defaultMessage: 'All Underlying Policies Added'
    }
});
